import Vue from 'vue';
import innerSvgPolyfill from 'innersvg-polyfill';

Vue.use(innerSvgPolyfill);
